/**
 * @module store/user/getters
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


/**
 * Getter: Возвращает залогинен ли текущий пользователь
 *
 * @returns {Boolean} True - пользователь залогинен, False - пользователь не залогинен
 */
const isLoggin = state => !!state.user;


/**
 * Getter: Возвращает текущего пользователя
 *
 * @returns {object}
 */
const user = state => state.user;

export default {
  isLoggin,
  user,
};
